import {PersInfCode} from 'module/PersonInfo/type/PersInfCode'
import {getSisDateAsNumber, parseSisDate, SisDate} from 'util/SisDateTime'
import CacheCollection from 'collection/CacheCollection'
import {fetchPersInfPerYearAPI} from 'module/PersonInfo/api/PersonInfoAPI'
import {PersInfTO} from 'generated/JavaTO'

const cache = new CacheCollection<Promise<PersInfTO[]>>('PT10S')

export function getPersInfForCodeFKey(persNr?: number, date?: number | SisDate, persInfCode?: PersInfCode, fkey?: string): Promise<string[]> {
	if (!persNr || !date || !persInfCode) return Promise.resolve([])
	if (!fkey || !fkey.trim()) fkey = " ";
	const dt = parseSisDate(date)
	const dtNum = getSisDateAsNumber(dt)
	const year = dt.year()

	const idPath = `${persNr}:${year}:${persInfCode}`

	let result = cache.getCache(idPath);
	if (!result) {
		result = fetchPersInfPerYearAPI(persNr, year, persInfCode).then(({data}) => data)
		cache.setCache(idPath, result)
	}
	return result.then((persInfList) => persInfList.flatMap(model => {
		let lines: string[] = []
		if (
			model.persNr == persNr &&
			model.code == persInfCode &&
			(!model.fkey.trim() || model.fkey === fkey) &&
			model.from <= dtNum &&
			model.to >= dtNum
		) {
			lines = model.details
		}
		return lines
	}))
}